export { TagsListPageView as default } from './TagsListPageView';
